import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from 'src/Core/Constant';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-summary-and-requirements-modal',
  templateUrl: './summary-and-requirements-modal.component.html',
  styleUrls: ['./summary-and-requirements-modal.component.scss']
})
export class SummaryAndRequirementsModalComponent {

  public data: any; // This should contain ApplicationTypeId & ApplicationGuid
  isCommentBoxShow = false;
  ApplicationTypeIdConstant = CONSTANTS.ApplicationTypeId
  constructor(
    private fb: FormBuilder,
    private api: SevaProfileService,
    private route: Router, // Inject Router
    protected dialogRef: NbDialogRef<SummaryAndRequirementsModalComponent>,
    private translationService: TranslationService
  ) {
    this.data = this.dialogRef;
   }

  close(): void {
    this.dialogRef.close();
  }

  back(): void {
    this.dialogRef.close({ action: 'back' });
  }

  proceed(): void {
   
  

    this.dialogRef.close(true);





  }

  // Translations
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }
}
